import { inject } from 'inversify';

import { STATUS } from '@/constants';
import { UserController } from '@/controllers/UserController';
import { service } from '@/decorators/service';
import { SignalrListener } from '@/decorators/signalr';
import { Logger } from '@/services/Logger';
import { Signalr } from '@/services/signalr/Signalr';
import { MiscTimestampsStore } from '@/stores/MiscTimestampsStore';
import { orderByField } from '@/utils/orderBy';
import { IListItem } from '~/api/IListItem';

@SignalrListener
@service(MiscTimestampsManager)
export class MiscTimestampsManager {
  @inject(Logger) protected logger: Logger;
  @inject(Signalr) protected signalr: Signalr;
  @inject(UserController) protected userController: UserController;
  @inject(MiscTimestampsStore) protected miscTimestampsStore: MiscTimestampsStore;

  get all() {
    const timestamps = this.miscTimestampsStore.all()
      .filter((timestamp) => timestamp.status !== STATUS.DISABLED);
    return orderByField(timestamps, this.miscTimestampsStore.valueKey);
  }

  find(id: string) {
    return this.miscTimestampsStore.find(id);
  }

  reset() {
    this.miscTimestampsStore.set([]);
  }

  updateMiscTimestamps(miscTimestamps: IListItem[]) {
    this.miscTimestampsStore.update(...miscTimestamps);
  }
}
